import { IconButton, styled } from '@mui/material';
import { TitleUserPage } from '../../styles';

export const InformationWrapper = styled('div')(({ theme }) => ({
  maxWidth: 532,
  width: '100%',
  color: theme.palette.novotalk.$textColorDarkBlue,
}));

export const InformationTitle = styled(TitleUserPage)({
  marginBottom: 32,
});

export const SummaryGrid = styled('div')(({ theme }) => ({
  display: 'grid',
  gridTemplateColumns: 'max-content max-content minmax(80px, 1fr)',
  gap: '16px 40px',
  padding: '16px 20px',
  marginBottom: 32,
  backgroundColor: theme.palette.novotalk.$resourcesListBgColor,
  borderRadius: 4,
  fontSize: 16,
  '& > div > div': {
    gap: 4,
  },
  '& > .wide': {
    gridColumn: '1 / -1',
  },
  '@media (max-width: 767px)': {
    gridTemplateColumns: '1fr',
    gap: 16,
    padding: 20,
  },
}));

export const InformationSection = styled('section')(({ theme }) => ({
  display: 'flex',
  flexDirection: 'column',
  gap: 16,
  paddingBottom: 32,
  marginBottom: 32,
  borderBottom: `1px solid ${theme.palette.novotalk.$resourcesTableBorderColor}`,
  '&.profile, &.login': {
    gap: 20,
  },
  '&:last-of-type': {
    paddingBottom: 0,
    marginBottom: 0,
    borderBottom: 0,
  },
}));

export const SectionTitle = styled('h2')(({ theme }) => ({
  margin: 0,
  color: theme.palette.novotalk.$textColorDarkBlue,
  fontSize: 18,
  fontWeight: 700,
  lineHeight: 1.2,
}));

export const FieldsGrid = styled('div')({
  display: 'flex',
  flexDirection: 'column',
  gap: 20,
  '&.profile > div > div, &.login > div > div': {
    gap: 8,
  },
    '&.program': {
      display: 'grid',
      gridTemplateColumns: '200px 200px',
      columnGap: 32,
      rowGap: 16,
    },
    '&.advanced': {
      gap: 10,
    },
    '& .MuiInputBase-root': {
      height: 32,
      fontSize: 14,
    },
    '&.profile .status .MuiFormControl-root': {
      width: '180px !important',
    },
    '&.program .MuiFormControl-root': {
      width: '200px !important',
    },
    '&.login .phone': {
      width: 208,
    },
    '&.login .phone > div > div': {
      gap: 16,
    },
    '&.login .phone > div > div > div:first-of-type': {
      flex: '0 0 160px',
    },
    '&.login .phone input': {
      height: 32,
    },
    '&.login .phone button': {
      width: 32,
      height: 32,
      flexBasis: 32,
      borderRadius: 0,
    },
  '& > .wide': {
    gridColumn: '1 / -1',
  },
  '@media (max-width: 767px)': {
    '&.program': {
      gridTemplateColumns: 'minmax(0, 200px)',
    },
    '& > .wide': {
      gridColumn: 'auto',
    },
  },
});

export const FieldSlot = styled('div')({
  minWidth: 0,
});

export const AdminActionsRow = styled('div')({
  display: 'flex',
  gap: 32,
  '@media (max-width: 767px)': {
    flexWrap: 'wrap',
  },
});

export const AdminActionItem = styled('div')({
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'flex-start',
  gap: 8,
  '& > div': {
    gap: 8,
  },
  '& button': {
    width: 'auto',
    height: 32,
    padding: '0 14px',
    border: 0,
    borderRadius: 4,
    fontSize: 14,
  },
});

export const LoginStatus = styled('div')(({ theme }) => ({
  display: 'flex',
  alignItems: 'center',
  gap: 6,
  minHeight: 20,
  color: theme.palette.novotalk.$textColorDarkBlue,
  fontSize: 14,
  '& .MuiSvgIcon-root': {
    color: theme.palette.success.main,
    fontSize: 18,
  },
  '&.not-set .MuiSvgIcon-root': {
    color: theme.palette.novotalk.$textColorDisabled,
  },
  '&.password-set': {
    height: 23,
    '& .MuiSvgIcon-root': {
      fontSize: 16,
    },
  },
  '&.mfa-set': {
    gap: 5,
    height: 23,
    color: theme.palette.success.main,
    fontWeight: 600,
    lineHeight: 1,
    '& .MuiSvgIcon-root': {
      fontSize: 16,
    },
  },
}));

export const EditorFields = styled('div')({
  display: 'grid',
  gridTemplateColumns: '150px 32px',
  gap: 16,
  alignItems: 'start',
  width: '100%',
  '& > .MuiTextField-root': {
    gridColumn: 1,
  },
});

export const NameEditorFields = styled(EditorFields)({
  gridTemplateColumns: '180px 180px 32px',
  '& > .MuiTextField-root': {
    gridColumn: 'auto',
  },
});

export const EditorInputGroup = styled('div')({
  display: 'flex',
  flexDirection: 'column',
  gap: 4,
  minWidth: 0,
});

export const EditorSubLabel = styled('span')(({ theme }) => ({
  color: theme.palette.novotalk.$textColorDisabled,
  fontSize: 12,
}));

export const EditorSaveAction = styled('span')({
  gridColumn: 2,
  gridRow: 1,
  alignSelf: 'end',
  '&.multi-row': {
    gridColumn: 3,
    gridRow: 1,
  },
});

export const EditorSaveButton = styled(IconButton)(({ theme }) => ({
  width: 32,
  height: 32,
  borderRadius: 0,
  color: theme.palette.novotalk.$actionButtonColor,
  backgroundColor: theme.palette.novotalk.$selectEnabledBgColorHover,
  '&:hover': {
    backgroundColor: theme.palette.novotalk.$selectEnabledBgColorActive,
  },
  '&:disabled': {
    opacity: 0.55,
  },
}));
